import useAuth from './useAuth';

import { TournamentTeams } from '@/types';

// eslint-disable-next-line react/display-name
export const useVersus = (playerClub: number) => {
  const { userInitialData } = useAuth();
  let versus;

  if (userInitialData && (Boolean(playerClub) || playerClub >= 0)) {
    const miniFixture = userInitialData.plantilla.miniFixture;

    if (miniFixture.length > 0) {
      const playerClubId = playerClub;
      const miniFixtureItem = miniFixture.find((item) => {
        return item.visit === playerClubId || item.loc === playerClubId;
      });

      let clubVSId = 0;

      if (miniFixtureItem) {
        if (miniFixtureItem.loc === playerClubId) {
          clubVSId = miniFixtureItem.visit;
        } else if (miniFixtureItem.visit === playerClubId) {
          clubVSId = miniFixtureItem.loc;
        }

        const clubVS = userInitialData.equipos_torneo.find(
          (team: TournamentTeams) => {
            return team.id === clubVSId;
          }
        );

        versus = clubVS?.nombre ?? null;
      }
    }
  }
  return { versus };
};
